<template>
  <v-flex style="overflow-x:auto">
    <table id="permissions-table">
      <thead>
        <tr>
          <th v-for="(resource, index) in permData" :key="index" class="permission-label"><div>{{resource.name}}</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(team, teamNo) in teams" :key="teamNo">
          <slot v-for="(resource, index) in permData">
            <td v-if="hasPermission(team, resource.name)" class="permission-check" :key="index"> <v-icon @click="togglePermission(team, resource.name)" color="success">check</v-icon> </td>
            <td v-if="!hasPermission(team, resource.name)" class="permission-check" :key="index"> <v-icon @click="togglePermission(team, resource.name)" color="error">close</v-icon> </td>
          </slot>
        </tr>
      </tbody>
    </table>
  </v-flex>
</template>

<script>

export default {
  props: { caseType: { type: Object, required: true }, teams: { type: Array, required: true } },
  computed: {
    resourceIds() {
      const resourceIds = []
      if (this.data.resources) {
        this.data.resources.forEach(function(res) {
          if (res.permissionType === "yes_no" && (res.name === "Export" || res.name === "Import")) {
            resourceIds.push(res.id)
          }
        })
      }
      return resourceIds
    },
    permData() {
      const permData = []
      if (this.data.resources) {
        this.data.resources.forEach(function(res) {
          if (res.permissionType === "yes_no" && (res.name === "Export" || res.name === "Import")) {
            permData.push(res)
          }
        })
      }
      return permData
    },
    permissions() {
      const permissions = []
      if (this.data.permissions) {
        this.data.permissions.forEach(function(permission) {
          if (permission) {
            if (this.resourceIds.includes(permission.resource.id)) {
              permissions.push(permission)
            }
          }
        })
      }
      return permissions
    },
    data() {
      if (this.caseType) {
        return {
          caseTypeId: this.caseType.id,
          permissions: this.caseType.permissions,
          resources: this.caseType.resources,
          accessTeams: this.caseType.teams,
          tasklists: this.caseType.tasklistTemplates
        }
      }
      return undefined
    }
  },
  methods: {
    hasPermission(team, resource) {
      if (this.data.permissions) {
        const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.name === resource))
        if (permission) {
          return (permission.permissionFlag === "yes")
        } else {
          return false
        }
      }
      return false
    },
    togglePermission(team, resource) {
      const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.name === resource))
      if (permission) {
        this.revokePermission(permission)
      } else {
        this.grantPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resource: resource })
      }
    },
    async grantPermission(permData) {
      const newPermission = await this.$store.dispatch("grantPermission", permData)
      this.data.permissions.push(newPermission)
    },
    async revokePermission(permData) {
      permData.caseTypeId = this.data.caseTypeId
      const response = await this.$store.dispatch("revokePermission", permData)
      if (!response.error) {
        const index = this.data.permissions.indexOf(permData)
        if (index >= 0) this.data.permissions.splice(index, 1)
      }
    }
  }
}
</script>
